import classNames from 'classnames';
import React from 'react';
import { Slider, SLIDER_TRACK_SIZE, SoundMutedIcon, SoundIcon } from 'wix-rich-content-ui-components';
import { s as styles } from '../audio.rtlignore-fd3d11e7.js';
import '../style-inject.es-746bb8ed.js';

const SoundControl = ({
  volume,
  muted,
  handleMute,
  handleVolumeChange
}) => {
  const onKeyPress = (e) => {
    if (e.key === "Enter") {
      handleMute();
    }
  };
  const onKeyDown = (e) => {
    const shouldDecrease = e.key === "ArrowDown" && volume > 0;
    const shouldIncrease = e.key === "ArrowUp" && volume < 1;
    const newVolume = shouldDecrease ? volume - 0.1 : shouldIncrease ? volume + 0.1 : volume;
    handleVolumeChange(parseFloat(newVolume.toFixed(1)));
  };
  const SoundIconComponent = muted ? SoundMutedIcon : SoundIcon;
  return /* @__PURE__ */ React.createElement(
    "button",
    {
      className: classNames(styles.audio_icon_button, styles.audio_volume_wrapper),
      onKeyPress,
      onKeyDown,
      "aria-label": "sound",
      type: "button"
    },
    /* @__PURE__ */ React.createElement("div", { className: styles.volume_slider_wrapper }, /* @__PURE__ */ React.createElement(
      Slider,
      {
        min: 0,
        max: 1,
        step: "any",
        value: volume,
        onChange: handleVolumeChange,
        onChangeCommitted: handleVolumeChange,
        languageDir: "ltr",
        dataHook: "audioVolumeSlider",
        trackSize: SLIDER_TRACK_SIZE.small,
        liveSiteWiring: true,
        tabIndex: -1
      }
    )),
    /* @__PURE__ */ React.createElement(SoundIconComponent, { className: styles.audio_sound_icon, onClick: handleMute })
  );
};

export { SoundControl as default };
//# sourceMappingURL=SoundControl.js.map
